import React from 'react';
import { ExploreConfig } from '@explore-with-ai/core';
import { ExploreWithAI } from '@explore-with-ai/widget';
import './WidgetPreview.css';

interface WidgetPreviewProps {
  config: ExploreConfig;
  onBack: () => void;
  onNext: () => void;
  onHandoff?: (mode: string) => void;
}

const WidgetPreview: React.FC<WidgetPreviewProps> = ({ config, onBack, onNext, onHandoff }) => {
  const handleAnalytics = (event: any) => {
    console.log('Widget Analytics Preview:', event);
  };

  return (
    <div className="widget-preview">
      <div className="widget-preview__card">
        <h2 className="widget-preview__title">Widget Preview</h2>
        <p className="widget-preview__description">
          This is how your widget will appear on websites. Test the functionality below.
        </p>

        <div className="widget-preview__demo">
          <div className="widget-preview__demo-header">
            <h3>Live Preview</h3>
            <p>Interactive widget with your configuration:</p>
          </div>
          
          <div className="widget-preview__demo-container">
            <ExploreWithAI 
              config={config}
              onAnalytics={handleAnalytics}
            />
          </div>
        </div>

        <div className="widget-preview__config-summary">
          <h3>Configuration Summary</h3>
          <div className="widget-preview__config-grid">
            <div className="widget-preview__config-item">
              <strong>Title:</strong> {config.title}
            </div>
            <div className="widget-preview__config-item">
              <strong>Source:</strong> {config.sourceName}
            </div>
            <div className="widget-preview__config-item">
              <strong>Format:</strong> {config.format}
            </div>
            <div className="widget-preview__config-item">
              <strong>Analysis Modes:</strong> {config.modes?.join(', ') || 'Default modes'}
            </div>
            <div className="widget-preview__config-item">
              <strong>AI Platforms:</strong> {config.enabledPlatforms?.join(', ') || 'All platforms'}
            </div>
            <div className="widget-preview__config-item">
              <strong>Target Audience:</strong> {config.audience ? config.audience.charAt(0).toUpperCase() + config.audience.slice(1) : 'General'}
            </div>
            {config.fields && config.fields.length > 0 && (
              <div className="widget-preview__config-item">
                <strong>Data Fields:</strong> {config.fields.map(f => f.name).join(', ')}
              </div>
            )}
          </div>
        </div>

        <div className="widget-preview__actions">
          <button
            onClick={onBack}
            className="widget-preview__back-button"
          >
            ← Back to Configure
          </button>
          <button
            onClick={onNext}
            className="widget-preview__next-button"
          >
            Generate Code →
          </button>
        </div>
      </div>
    </div>
  );
};

export default WidgetPreview;
